import angular from 'angular';
import NavigationFactory from './navigation.factory';

let navigationModule = angular.module('app.navigation', [])

.factory('Navigation', NavigationFactory)

.name;

export default navigationModule;


// WEBPACK FOOTER //
// ./client/app/common/navigation/index.js